// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Quote_wrapper__3l2iR","author":"Quote_author__3vRAk","openQuote":"Quote_openQuote__aUtjq","closeQuote":"Quote_closeQuote__F4KFC"};